import { createSlice } from '@reduxjs/toolkit'
import {
    IEnquiryState
} from './types'
import { createEnquiryThunk } from './thunks';

const initialState: IEnquiryState = {
    initial: null,
    inProgress: false,
    error: ''
}

const enquirySlice = createSlice({
    name: 'enquiry',
    initialState,
    reducers: {
        resetEnquiryErrorAction: (state) => {
            state.error = null
        },
    },
    extraReducers: (builder) => {
        // upload-candidate-documents
        builder.addCase(createEnquiryThunk.pending, (state, action) => {
            state.inProgress = true
            state.error = null
        })
        builder.addCase(createEnquiryThunk.fulfilled, (state, action) => {
            state.inProgress = false
        })
        builder.addCase(createEnquiryThunk.rejected, (state, action) => {
            state.inProgress = false
            state.error = action.payload
        })
    }
});

export const {
    resetEnquiryErrorAction
} = enquirySlice.actions

export default enquirySlice.reducer;